import { useRef, useEffect } from 'react';

/**
 * Wraps a product block and fires the impression callback
 * when it enters the viewport (once per mount).
 */
export default function ImpressionTracker({ productId, category, onImpression, children }) {
  const ref = useRef(null);
  const firedRef = useRef(false);

  useEffect(() => {
    if (!ref.current || firedRef.current || !onImpression) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !firedRef.current) {
          firedRef.current = true;
          onImpression(productId, category);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [productId, category, onImpression]);

  return <div ref={ref}>{children}</div>;
}
